<template>
    <div class="diagram-title-bar clearfix">
        <span class="diagram-title eight">六爻起卦</span>
        <span class="diagram-title six" v-if="!fromEmbedded" @click="clickEight">八字起盘</span>
        <div class="diagram-type" @click="clickRecord">
            <span class="cur">卦例库</span>
        </div>
    </div>
</template>
<script>

export default {
    name: 'DiagramTitleBar',
    computed: {
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded
        }
    },
    methods:{
        clickEight() {
            this.$router.replace('/collate');
            var curPath = this.$router.history.current.path,
                userInfo = this.$store.state.userData.info;
            let hideAct = curPath.indexOf('embedded') !== -1 || userInfo.vip == 30;
            setTimeout(() => {
                this.$store.dispatch('activity/getActivityInfo', {hideAct: hideAct});
            }, 1000);
        },
        clickRecord() {
            var curPath = this.$router.history.current.fullPath;
            curPath = curPath.replace('diagram', 'diagramrecord')
            this.$router.replace(curPath);
        }
    }
}
</script>